import React, { ReactNode, useEffect, useState } from "react";

export function BottomModal({
  show,
  children,
}: {
  show: boolean;
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (!show) {
      setTimeout(() => {
        setIsOpen(false);
      }, 300);
    } else {
      setIsOpen(true);
    }
  }, [show]);

  if (!show && !isOpen) {
    return <></>;
  } else {
    const isModalOpen = show && isOpen;
    return (
      <div
        className={`         
        fixed inset-0 bg-black flex items-end justify-center z-50
        transition-colors duration-300 ease-out 
        ${isModalOpen ? "bg-opacity-50" : "bg-opacity-0"}`}
      >
        <div
          className={`
            bg-base-100 rounded-t-lg shadow-xl w-full max-w-md
            transform transition-transform duration-300 ease-out
            ${isModalOpen ? "translate-y-0" : "translate-y-full"}
            h-full md:h-[90vh] overflow-y-auto flex flex-col
          `}
        >
          {children}
        </div>
      </div>
    );
  }
}
